/*
 * Created on Wed Oct 11 2023 4:56:55 PM
 *
 * ***************************************************************************************
 * Copyright (c) AVPS Technologies Inc 2023 
 *
 * All Rights Reserved
 * Unpublished rights are reserved under the copyright laws of the United States.
 * The software contained in this media is proprietary to and embodies confidential
 * the technology of AVPS Technologies Inc. Possession, use, duplication or
 * dissemination of the software and media is authorized only pursuant to a valid
 * written license from AVPS Technologies Inc.
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * RESTRICTED RIGHTS LEGEND Use, duplication, or disclosure by the U.S. Government
 * is subject to restrictions as set forth in Subparagraph (c) (1) (ii) of DFARS
 * 252.227-7013 or in FAR 52.227-19, as applicable.
 ****************************************************************************************
 */

import React from 'react';
import { getStatusConfig } from '../utils/orderUtils';

const StatusBadge = ({ order }) => {
    const status = order?.currentStatus || order?.status || 'PAID';
    const config = getStatusConfig(status);

    return (
        <span className={`inline-flex px-2 py-1 rounded-md text-xs font-medium ${config.color} ${config.bg} border ${config.border}`}>
            {config.label}
        </span>
    );
};

export default StatusBadge;